export default {
    VERIFICATION: {
        SEND: 'studio-email-verification-send',
        SENT: 'studio-email-verification-sent'
    }
};
